<template>
  <img src="@/assets/databg.jpg" class="aa-bg" alt="" />
  <div class="aa" :class="{'pc-aa': !isMobile}">
    <!-- <img src="@/assets/download-icon2.png" alt="" class="icon1" /> -->
    <div class="qu">
      渠道名:&nbsp;&nbsp;&nbsp;
      <span class="szie">{{ channelname }}</span>
    </div>
    <div class="qidap">
      这是一个咕噜分发默认提供的渠道落地页，仅用于测试使用。通过此页面安装带来的任何安装，将自动归因于此渠道，并能实时查看报表数据。
    </div>

    <Row class="felx">
      <Col
        :xs="8"
        :sm="8"
        :lg="6"
        class="felx-items"
        v-for="(app, index) in appList"
        :key="app.id"
      >
        <div class="noe">
          <img :src="app.icon" alt="" />
          <div class="nasd">{{ app.name }}{{ app.type == 1 ? '.ipa' : '.apk' }}</div>
          <div class="unp" @click="downloadFile(app.dUrl)">下载</div>
        </div>
      </Col>
    </Row>

    <!-- <Card style="width: 50%; margin: auto">
      <Table :columns="columns" :data-source="data">
        <template #size="{ record }">
          <div>
            {{ convertStorageSize(record.size) }}
          </div>
        </template>
      </Table>
    </Card> -->

    <!-- <img src="@/assets/download-icon1.png" alt="" class="icon2" /> -->
  </div>
</template>

<script setup>
import { Table, Card, Row, Col } from "ant-design-vue";
import { apiDomain, request2 } from "@/request.js";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { showModal2 } from "@/utils/showModal";


function isMobileDevice() {
	return window.matchMedia("only screen and (max-width: 960px)").matches;
}

const isMobile = ref(isMobileDevice());

const route = useRoute();

const data = ref([]);
const columns = [
  {
    title: "应用名称",
    dataIndex: "name",
  },
  {
    title: "类型",
    dataIndex: "type",
  },
  {
    title: "包名",
    dataIndex: "bundle_id",
  },
  {
    title: "大小",
    dataIndex: "size",
    customRender({ text }) {
      return convertStorageSize(text);
    },
  },
  {
    title: "下载链接",
    dataIndex: "dUrl",
  },
];

function convertStorageSize(totalSpace) {
  const units = ["B", "KB", "MB", "GB"];
  let size = totalSpace;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`;
}
const appList = ref([]);
const channelname = ref("");
function getData() {
  request2(
    apiDomain + "/api/data/channel-apps",
    {
      id: route.params.id,
    },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
      },
    }
  )
    .then((res) => {
      console.log(res, "接口返回的");
      if (res?.data?.code == 0) {
        data.value = res.data.data;
        appList.value = res.data.data.list;
        channelname.value = res.data.data.channelName;
        console.log(res.data);
      } else {
        // 如果接口返回错误码，但没有抛出异常
        showModal2({
          title: "提示",
          content: res?.data?.msg || "请求失败",
          hideConfirmBtn: true,
        });
      }
    })
    .catch((err) => {
      // 如果接口请求失败或抛出异常
      showModal2({
        title: "提示",
        content: err?.msg || err?.message || "请求失败，请稍后重试！",
        hideConfirmBtn: true,
      });
    });
}
const downloadFile = (fileUrl) => {
  if (!fileUrl) {
    showModal2({
      title: "提示",
      content: "暂无下载链接",
      hideConfirmBtn: true,
    });
    return;
  }

  // 直接在新标签页打开下载页面
  window.open(fileUrl, "_blank");
};

const currentIndex = ref(0);

getData();
</script>
<style lang="less" scoped>
.nasd {
  margin: 20px 0;
  font-size: 16px;
}
.qus {
  opacity: 0.18;
  color: rgba(2, 2, 2, 0.5);
  font-size: 38px;
  font-weight: 900;
  font-family: 思源黑体;
  text-align: center;
  position: relative;
  top: 25px;
  margin: auto;
}
.felx {
  // width: 50%;
  // width: 50vw;
  width: 100%;
  max-width: 700px;
  margin: 58px auto auto auto;
  // display: flex;
  // flex-wrap: wrap;
  max-height: 450px;
  height: max-content;
  padding: 23px 0 18px 0;
  // box-shadow: 0 1px 26px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow-y: auto;

  .felx-items {
    display: flex;
    justify-content: center;
  }
}

.unp {
  margin: 21px auto;
  padding: 6px 20px;
  // background: #85d931;
  color: rgba(113, 188, 39, 1);
  cursor: pointer;
  border-radius: 10px;
  width: max-content;
  box-sizing: border-box;
  border: 1px solid rgba(113, 188, 39, 1);
  border-radius: 5px;
}
.noe {
  width: 100px;
}
.noe img {
  width: 70px;
  border-radius: 10px;
  height: 70px;
}
.qu {
  color: rgba(51, 51, 51, 1);
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}
.icon1 {
  width: 12%;
  height: auto;
  position: absolute;
  top: 0;
  /* right: 0; */
  left: 0;
}
.icon2 {
  width: 600px;
  height: auto;
  position: absolute;
  /* top: 0; */
  right: 0;
  /* left: 0; */
}
.aa {
  text-align: center;
  padding: 42px 10px 10px 10px;
  position: relative;
  z-index: 4;
  &.pc-aa {
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.aa-bg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  user-select: none;
  -webkit-user-drag: none;
  z-index: 1;
}
.ds {
  border: 1px solid red;
  width: 30%;
  margin: auto;
  text-align: center;
}
.qidap {
  // width: 50%;
  // height: 90px;
  // padding: 10px;
  // border: 1.5px dashed #7bc830;
  // margin: 51px auto;
  // font-size: 16px;
  // text-align: left;
  // color: gray;

  color: rgba(144, 196, 0, 1);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  text-align: justify;
  padding: 20px;
  max-width: 787px;
  box-sizing: border-box;
  border: 1px dashed rgba(144, 196, 0, 1);
  border-radius: 5px;
  background: rgba(250, 255, 244, 1);
  margin: 40px auto;
}
// .szie {
//   font-size: 26px;
// }
// @media (max-width: 768px) {
//   .szie {
//     font-size: 23px;
//   }
//   .icon1 {
//     width: 24%;
//     height: auto;
//     position: absolute;
//     top: 0;
//     /* right: 0; */
//     left: 0;
//   }
//   .qidap {
//     width: 98%;
//   }
//   .felx {
//     width: 92%;
//     margin: 42px auto auto auto;
//   }
//   .noe img {
//     width: 62%;
//     border-radius: 10px;
//     height: 36%;
//   }
//   .noe {
//     /* margin: auto; */
//     width: 25%;
//   }
//   .unp {
//     width: 63%;
//     margin: 11px auto 24px auto;
//   }
//   .nasd {
//     margin: 11px 0;
//   }
//   .icon2 {
//     width: 92%;
//   }
//   .qu {
//     font-size: 26px;
//   }
//   .qidap {
//     margin: 40px auto;
//   }
// }
</style>
